import { observer } from 'mobx-react-lite';
import qs from 'qs';
import { ReactElement, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuthService } from '../auth.service';
import { ResendConfirmationEmail } from '../components/emailConfirmation/ConfirmEmailResend';
import { ResendStatus } from './ConfirmEmailContainer';

export const ResendConfirmEmailContainer = observer((): ReactElement => {
  const authService = useAuthService();

  const [resendStatus, setResendStatus] = useState<ResendStatus>('NotSent');
  const { search } = useLocation();

  const handleResendActivationEmail = async (): Promise<void> => {
    setResendStatus('Sending');
    const parsedSearch = qs.parse(search.slice(1)) as { email: string };

    await authService.resendConfirmationEmail({ email: parsedSearch.email });
    setResendStatus('Sent');
  };

  return (
    <ResendConfirmationEmail
      resendStatus={resendStatus}
      onResendActivationEmailClick={handleResendActivationEmail}
    />
  );
});
